import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { FileUploadModel, CreateBlankFileUpload } from '../../../models/file-upload.model';
import { CreateBlankViewer } from '../../../models/viewer-model';
import { E5coreUiWorkAttachmentViewerComponent } from '../../e5core-ui-work-attachment-viewer/e5core-ui-work-attachment-viewer.component';
import { KeyValuePair } from '../../../util/key-value-pair';
import { FieldDefinitionModel } from '../../../models/field-definition.model';
import { Guid } from 'guid-typescript';
import { E5coreUiConversationViewerComponent } from '../../e5core-ui-conversation-viewer/e5core-ui-conversation-viewer.component';

@Component({
  selector: 'e5core-ui-work-item-material',
  templateUrl: './e5-core-ui-work-item-material.component.html',
  styleUrls: ['./e5-core-ui-work-item-material.component.css']
})
export class E5CoreUiWorkItemMaterialComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() workItem: WorkItemModel ;

  fileUpload$: BehaviorSubject<FileUploadModel>;

  displayedDate : Date;
  displayedTime : String ;
  diariseReasonTextValue : String ;
  workId : string;

  workRelatedItemFields: KeyValuePair[] = [
    {key: "Category1Name", value: "Product"}, 
    {key: "Category2Name", value: "Business Unit"}, 
    {key: "Category3Name", value: "Category"}, 
    {key: "StatusName", value: "Status"},
    {key: "Reference", value: ""},
    {key: "AssignedUser", value: ""}
  ];

  selectFromListFields: FieldDefinitionModel[] = [
    {fieldId: "FullUrl", fieldCode: "fullUrl", name: "Full Url", display: false},
    {fieldId: "FileLeafRef", fieldCode: "fileLeafRef", name: "Document Name", display: true},
    {fieldId: "_dlc_DocId", fieldCode: "_dlc_DocId", name: "Policy No", display: true},
    {fieldId: "_UIVersionString", fieldCode: "_UIVersionString", name: "Version No", display: true},
    {fieldId: "Synonym", fieldCode: "synonym", name: "Synonyms", display: true}
  ];

  @ViewChildren(E5coreUiWorkAttachmentViewerComponent)
  public attachmentViewerComponents: QueryList<E5coreUiWorkAttachmentViewerComponent>;

  @ViewChildren(E5coreUiConversationViewerComponent)
  public conversationViewerComponent: QueryList<E5coreUiConversationViewerComponent>;

  constructor() { }

  ngOnInit() {
    const blankFileUpload = CreateBlankFileUpload() ;
    this.fileUpload$ = new BehaviorSubject<FileUploadModel>(blankFileUpload) ;
    this.fileUpload$.subscribe(
      m => {},
      error => {
        console.error(error) ;
      }
    )
    
    if (typeof this.workItem$ == 'undefined') {
      console.error('e5core-ui-work-related-items [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        wim => {
          if (wim.workId != null && wim.workId != Guid.EMPTY) {
            this.workId = wim.workId;
          }
        }
      )
    }
  }

  onConversationView(event) : void {

    const viewerModel = CreateBlankViewer() ;
    viewerModel.workId = this.workId;

    this.conversationViewerComponent.forEach(element => {
        element.showViewer(viewerModel);
    });
  }

  onAttachmentSelect(event) : void {
    const viewerModel = CreateBlankViewer() ;
    viewerModel.id = event.attachmentId;
    viewerModel.workId = event.workId;

    this.attachmentViewerComponents.forEach(element => {
      if (element.viewerType == "0")
        element.showViewer(viewerModel);
    });
  }

  onGenerateDocument(event) : void {
    const viewerModel = CreateBlankViewer() ;
    viewerModel.fullUrl = event.fullUrl;
    viewerModel.workId = event.workId;

    this.attachmentViewerComponents.forEach(element => {
      if (element.viewerType == "2")
        element.showViewer(viewerModel);
    });
  }
  
  onListItemViewEvent(event) {
    debugger;
    const viewerModel = CreateBlankViewer() ;
    viewerModel.name = event.name;
    viewerModel.fullUrl = event.fullUrl;

    this.attachmentViewerComponents.forEach(element => {
      if (element.viewerType == "1")
        element.showViewer(viewerModel);
    });
  }
  
  onListItemSelectEvent(event) {
    alert("You have selected: "+ event.element.fileLeafRef);
  }
  
  onWorkItemSelect(event) {
    alert("You are opening : "+ event.workId);
  }

  //Diarise
  onDiarisePeriodOptionClick($event) {    
  }

  onDiariseButtonClick($event) {    
  }

  onDateChange($event) {    
  }

  onDiariseReasonTextChange($event) {    
  }
}